import { Timestamp } from "firebase/firestore";
import * as Yup from 'yup';
import { ObjectSchema } from 'yup';
import { SKMediaType } from "../api/shared/uploadService";
import { ChannelState, ChannelType } from "./SKChannel";
import { Location } from "../pages/artifacts/create/container/components/AddLocatioinSeacrh";
import { ContentAgeRestriction } from "../api/enums";


export interface ActionOnItem {
  itemid: string;
  action: ActionItem;
}

export enum ModArtifactType {
  Review = "In Review",
  EditReview = "Edit Review",
  Active = "Active",
  Withdrawn = "Withdrawn",
  Rejected = "Rejected",
  Flagged = "Flagged",
}

export enum CreatorArtifactType {
  Review = "In Review",
  Draft = "Draft",
  Active = "Active",
  Withdrawn = "Withdrawn",
  Rejected = "Rejected",
}

// export enum ActionItem {
//     pre_approve = "Pre Approve",
//     duplicate = "Duplicate",
//     delete = "Delete",
//     withdraw = "Withdraw",
//     move_to_free = "Move to Free",
//     move_to_subscription = "Move to Subscription",
//     submit_for_review = "Submit for Review",
//     unpublish = "Unpublish",
//     publish = "Publish",
//     approve = "Approve",
//     do_not_approve = "Do not Approve",
//     block = "Block",
//     suspend = "Suspend",
//     remove_suspension = "Remove Suspension",
//     remove_block = "Remove Block",
//     keep_published = "Keep Published",
//     active = "Make Active",
//     keep_active = "Keep Active",
//     edit = "Edit",
//     remove = "Remove",
//     make_inactive = "Make Inactive"
//   }
  
  // export enum State {
  //   approved = "approved",
  //   draft = "draft",
  //   published = "published",
  //   need_more_info = "need_more_info",
  //   rejected = "rejected",
  //   review = "review",
  //   withdrawal = "withdrawal",
  //   blocked = "blocked",
  //   suspended = "suspended",
  // }

  export enum ContentState {
    IN_REVIEW = "IN_REVIEW",
    ACTIVE = "ACTIVE",
    DRAFT = "DRAFT",
  }

  export enum ContentSubstate {
    NONE = "NONE",
    EDIT_IN_DRAFT = "EDIT_IN_DRAFT",
    EDIT_IN_REVIEW = "EDIT_IN_REVIEW",
    EDIT_REJECTED = "EDIT_REJECTED",
    EDIT_APPROVED = "EDIT_APPROVED",
    WITHDRAWN = "WITHDRAWN",
    REJECTED = "REJECTED",
    DEACTIVATED = "DEACTIVATED",
  }



  export const ContentStateToSubstateMap: Record<ContentState, ContentSubstate[]> = {
    [ContentState.IN_REVIEW]: [ContentSubstate.NONE],
    [ContentState.ACTIVE]: [
      ContentSubstate.NONE,
      ContentSubstate.EDIT_IN_DRAFT,
      ContentSubstate.EDIT_IN_REVIEW,
      ContentSubstate.EDIT_REJECTED,
      ContentSubstate.EDIT_APPROVED,
    ],
    [ContentState.DRAFT]: [ContentSubstate.NONE, ContentSubstate.WITHDRAWN, ContentSubstate.REJECTED],
  };
  
   export enum ContentActionType {
      review = "In Review",
      edit_review = "Edit Review",
      active = "Active",
      withdrawn = "Withdrawn",
      rejected = "Rejected"
    }
  
    export enum ActionItem {
      duplicate = "Duplicate",
      delete = "Delete Content",
      withdraw = "Withdraw Content",
      submit_for_review = "Submit for Review",
      approve = "Approve Content",
      reject = "Reject Content",
      reject_edit = "Reject Edits",
      approve_edit = "Approve Edits",
      edit = "Edit Content Details",
      edit_submit = "Edit & Submit",
      deactive = "Deactivate Content",
      review_in_progress = "Review in Progress",
      keep_published = "Continue Published"
    }
  
    export interface ActionOnItem {
      itemid: string;
      action: ActionItem;
    }
  
    export const AdminStateActions: {
      [key in ContentState]?: {
        [key in ContentSubstate]?: ActionItem[];
      };
    } = {
      [ContentState.IN_REVIEW]: {
        [ContentSubstate.NONE]: [
          ActionItem.approve,
          ActionItem.reject,
        ],
      },
      [ContentState.ACTIVE]: {
        [ContentSubstate.NONE]: [
          ActionItem.reject,
        ],
        [ContentSubstate.EDIT_IN_REVIEW]: [
          ActionItem.reject,
        ],
        [ContentSubstate.EDIT_REJECTED]: [
          ActionItem.reject,
        ],
        [ContentSubstate.EDIT_IN_DRAFT]: [
          ActionItem.reject,
        ],
        [ContentSubstate.EDIT_APPROVED]: [
          ActionItem.reject,
        ],
      },
      [ContentState.DRAFT]: {
        [ContentSubstate.REJECTED]: [
          ActionItem.delete,
        ],
        [ContentSubstate.WITHDRAWN]: [
          ActionItem.delete,
        ],
      },
    };
  
    export const AdminStateEditActions: {
      [key in ContentState]?: {
        [key in ContentSubstate]?: ActionItem[];
      };
    } = {
      [ContentState.ACTIVE]: {
        [ContentSubstate.EDIT_IN_REVIEW]: [
          ActionItem.reject_edit,
          ActionItem.approve_edit,
  
        ]
      },
    };
  
    export const CreatorStateActions: {
      [key in ContentState]?: {
        [key in ContentSubstate]?: ActionItem[];
      };
    } = {
      [ContentState.IN_REVIEW]: {
        [ContentSubstate.NONE]: []
      },
      [ContentState.ACTIVE]: {
        [ContentSubstate.NONE]: [
          ActionItem.withdraw,
        ],
        [ContentSubstate.EDIT_IN_DRAFT]: [
          ActionItem.withdraw,
        ],
        [ContentSubstate.EDIT_IN_REVIEW]: [
          ActionItem.withdraw,
        ],
        [ContentSubstate.EDIT_REJECTED]: [
          ActionItem.withdraw,
        ],
        [ContentSubstate.EDIT_APPROVED]: [
          ActionItem.withdraw,
        ],
      },
      [ContentState.DRAFT]: {
        [ContentSubstate.REJECTED]: [
          ActionItem.delete,
        ],
        [ContentSubstate.WITHDRAWN]: [
          ActionItem.delete,
        ],
        [ContentSubstate.NONE]: [
          ActionItem.delete,
        ],
      },
    };
  
    // export const CreatorStateEditActions: {
    //   [key in ContentState]?: {
    //     [key in ContentSubstate]?: ActionItem[];
    //   };
    // } = {
    //   [ContentState.ACTIVE]: {
    //     [ContentSubstate.EDIT_IN_DRAFT]: [
    //       ActionItem.withdraw,
    //     ],
    //     [ContentSubstate.EDIT_IN_REVIEW]: [
    //       ActionItem.withdraw,
    //     ],
    //     [ContentSubstate.EDIT_REJECTED]: [
    //       ActionItem.withdraw,
    //     ],
    //   }
    // };
  
  
    export function getContentAdminActionableItems(state: ContentState, subState: ContentSubstate ): ActionItem[] {
      
      console.log("getAdminActionableItems");
      // Find actions for the given state and substate
      const stateActions = AdminStateActions[state];
      if (!stateActions) return [];
    
      const substateActions = stateActions[subState];
      return substateActions || [];
    }
  
    export function getContentAdminActionableEditItems( status: ContentState, subStatus: ContentSubstate ): ActionItem[] {
      
    
      // Find actions for the given state and substate
      const stateActions = AdminStateEditActions[status];
      if (!stateActions) return [];
    
      const substateActions = stateActions[subStatus];
      return substateActions || [];
    }
  
    export function getContentCreatorActionableItems( status: ContentState, subStatus: ContentSubstate ): ActionItem[] {
    
      // Find actions for the given state and substate
      const stateActions = CreatorStateActions[status];
      if (!stateActions) return [];
    
      const substateActions = stateActions[subStatus];
      return substateActions || [];
    }

    

  export const getContentStatusString = (status?: ContentState, subStatus?: ContentSubstate, isEdit: boolean = false): string => {
  
        switch (status) {
          case ContentState.ACTIVE :
            if(isEdit){
              switch (subStatus) {
                case ContentSubstate.EDIT_APPROVED:
                  return "Edits Approved"
                case ContentSubstate.EDIT_IN_DRAFT:
                  return "Edits in Draft"
                case ContentSubstate.EDIT_IN_REVIEW:
                  return "Edits in Review"
                case ContentSubstate.EDIT_REJECTED:
                  return "Edits Rejected"
                default:
                  return "Active"
              } 
            }else{
              return "Active"
            }
          case ContentState.DRAFT :
           
            switch (subStatus) {
              case ContentSubstate.NONE:
                return "Draft"
              case ContentSubstate.REJECTED:
                return "Rejected"
              case ContentSubstate.WITHDRAWN:
                return "Withdrawn"
              default:
                return ""
            }
          
          case ContentState.IN_REVIEW :
            return "In Review"
  
          default:
           return "Status Not found"
      
        }
    }
  
    export const getContentHistoryStatusString = (status: ContentState, subStatus: ContentSubstate, isEdit: boolean = false): string => {
  
      switch (status) {
        case ContentState.ACTIVE :
          if(isEdit){
            switch (subStatus) {
              case ContentSubstate.EDIT_APPROVED:
                return "Edits Approved"
              case ContentSubstate.EDIT_IN_DRAFT:
                return "Edits in Draft"
              case ContentSubstate.EDIT_IN_REVIEW:
                return "Edits in Review"
              case ContentSubstate.EDIT_REJECTED:
                return "Edits Rejected"
              default:
                return "Active"
            } 
          }else{
            return "Active"
          }
        case ContentState.DRAFT :
         
          switch (subStatus) {
            case ContentSubstate.NONE:
              return "Draft"
            case ContentSubstate.REJECTED:
              return "Rejected"
            case ContentSubstate.WITHDRAWN:
              return "Withdrawn"
            default:
              return ""
          }
        
        case ContentState.IN_REVIEW :
          return "In Review"
    
      }
  }
  
    export const getContentEditStatusString = ( subStatus: ContentSubstate): string => {
      switch (subStatus) {
          case ContentSubstate.EDIT_APPROVED:
            return "Edits Approved"
          case ContentSubstate.EDIT_IN_DRAFT:
            return "Edits in Draft"
          case ContentSubstate.EDIT_IN_REVIEW:
            return "Edits in Review"
          case ContentSubstate.EDIT_REJECTED:
            return "Edits Rejected"
          default:
            return "Moderator Action"
      } 
    }
  
  const actionToStateMap: {
    [key in ActionItem]?: { state: ContentState; substate: ContentSubstate }[];
  } = {
    [ActionItem.approve]: [
      { state: ContentState.ACTIVE, substate: ContentSubstate.NONE },
    ],
    [ActionItem.reject]: [
      { state: ContentState.DRAFT, substate: ContentSubstate.REJECTED },
    ],
    [ActionItem.withdraw]: [
      { state: ContentState.DRAFT, substate: ContentSubstate.WITHDRAWN },
    ],
    [ActionItem.approve_edit]: [
      { state: ContentState.ACTIVE, substate: ContentSubstate.EDIT_APPROVED },
    ],
    [ActionItem.reject_edit]: [
      { state: ContentState.ACTIVE, substate: ContentSubstate.EDIT_REJECTED },
    ],
    [ActionItem.edit]: [
      { state: ContentState.ACTIVE, substate: ContentSubstate.EDIT_IN_DRAFT },
    ],
    [ActionItem.edit_submit]: [
      { state: ContentState.ACTIVE, substate: ContentSubstate.EDIT_IN_REVIEW },
    ],
    [ActionItem.submit_for_review]: [
      { state: ContentState.IN_REVIEW, substate: ContentSubstate.NONE },
    ],
    [ActionItem.duplicate]: [
      { state: ContentState.DRAFT, substate: ContentSubstate.NONE },
    ],
  };

  export function getContentStatesForAction(actionItem: ActionItem): { state: ContentState; substate: ContentSubstate }[] {
  
    // Return the states and substates for the given action item or an empty array if none are found
    return actionToStateMap[actionItem] || [];
  }
      
  export enum Tier {
    free = "free",
    subscription = "paid",
  }


  export enum ArtifactType {
    text = "text",
    photo = "photo",
    video = "video",
    audio = "audio",
    link = "link",
    story = "story",
    list = "list",
    guide = "guide",
    journal = "journal",
    letter = "letter",
    poll = "poll",
    greeting = "greetingCard",
    place = "place",
    event = "event",
    document = "document",
  }

  const artifactTypeImages = {
    text: "/icons/Text.png",
    photo: "/icons/Photo.png",
    video: "/icons/Video.png", 
    audio: "/icons/Audio.png", 
    link: "/icons/Link.png", 
    story: "/icons/Story.png", 
    list: "/icons/List.png",
    guide: "/icons/Guide.png", 
    journal: "/icons/Journal.png", 
    letter: "/icons/Letter.png", 
    poll: "/icons/Poll.png", 
    greetingCard: "/icons/Greeting.png", 
    place: "/icons/Place.png", 
    event: "/icons/Event.png", 
    document: "/icons/Document.png"
  };
  
  export const getArtefactIcon= (obj: ArtifactType): string => {
    return artifactTypeImages[obj] || ''; // Fallback to a default image
  };

  export enum TopicType {
    food = "food",
    design = "design",
    culture = "culture",
    travel = "travel",
    fashion = "fashion",
    shopping = "shopping",
    sports = "sports",
    entertainment = "entertainment",
    technology = "technology",
    health = "health",
    education = "education",
    kids = "kids",
    books = "book",
    environment = "environment",
    music = "music",
    business = "business",
    games = "games",
  }

  export const  TopicTypeString = {
    "entertainment" : "Entertainment",
    "food" : "Food",
    "travel" : "Travel",
    "music" : "Music",
    "fashion" : "Fashion",
    "health" : "Fitness",
    "technology" : "Technology",
    "sports" : "Sports",
    "culture" : "Culture",
    "shopping" : "Shopping",
    "kids" : "Kids and Family",
    "business" : "Business",
    "environment" : "Nature",
    "education" : "Education",
    "games" : "Games",
    "book" : "Books",
    "design" : "Design",
  }


  
  export enum GreetingsType {
    birthday = "birthday",
    christmas = "christmas",
    festival = "festivals",
    holidays = "holidays",
    memorable = "memorable",
    mothersday = "mothersDay",
    newyears = "newYear",
    specialday = "specialDay",
    veterans = "veterans"
  }

  export interface GreetingItem {
    greetingImgSrc: string;
    serverUrl:string;
    greetingType: GreetingsType;
    greetingName: GreetingsType;
    greetingPosition?: { x: number; y: number }; 
    imagePosition?: { x: number; y: number }; 
    greetingTextColor?: string; 
    IsHaveImage?: boolean; 
    greetingImage?: string; 
  }

  export const GreetingTypes: GreetingItem[] = [
    {
      greetingImgSrc: "/images/greetings/holidays.png",
      serverUrl:`https://firebasestorage.googleapis.com/v0/b/skarvo-sudham-business.firebasestorage.app/o/channel_content_media%2Fgreetings%2F${GreetingsType.holidays.toLowerCase()}.png?alt=media&token=a618c6ad-f88a-47f9-a3f5-31f8d0b1cfb7`,
      greetingType: GreetingsType.holidays,
      greetingName: GreetingsType.holidays,
      greetingPosition: { x: 20, y: 135 },
      greetingTextColor: "#FFFFFF",
      IsHaveImage: false,
      greetingImage: "",

    },
    {
      greetingImgSrc: "/images/greetings/birthday.png",
      serverUrl:`https://firebasestorage.googleapis.com/v0/b/skarvo-sudham-business.firebasestorage.app/o/channel_content_media%2Fgreetings%2F${GreetingsType.birthday.toLowerCase()}.png?alt=media&token=a618c6ad-f88a-47f9-a3f5-31f8d0b1cfb7`,
      greetingType: GreetingsType.birthday,
      greetingName: GreetingsType.birthday,
      greetingPosition: { x: 20, y: 140 },
      greetingTextColor: "#000000",
      IsHaveImage: false,
      greetingImage: "",
    },
    {
      greetingImgSrc: "/images/greetings/specialday.png",
      serverUrl:`https://firebasestorage.googleapis.com/v0/b/skarvo-sudham-business.firebasestorage.app/o/channel_content_media%2Fgreetings%2F${GreetingsType.specialday.toLowerCase()}.png?alt=media&token=a618c6ad-f88a-47f9-a3f5-31f8d0b1cfb7`,
      greetingType: GreetingsType.specialday,
      greetingName: GreetingsType.specialday,
      greetingPosition: { x: 25, y: 130 },
      greetingTextColor: "#000000",
      IsHaveImage: false,
      greetingImage: "",
    },
    {
      greetingImgSrc: "/images/greetings/newyear.png",
      serverUrl:`https://firebasestorage.googleapis.com/v0/b/skarvo-sudham-business.firebasestorage.app/o/channel_content_media%2Fgreetings%2F${"newyear"}.png?alt=media&token=a618c6ad-f88a-47f9-a3f5-31f8d0b1cfb7`,
      greetingType: GreetingsType.newyears,
      greetingName: GreetingsType.newyears,
      greetingPosition: { x: 25, y: 125 },
      greetingTextColor: "#FFFFFF",
      IsHaveImage: false,
      greetingImage: "",
    },
    {
      greetingImgSrc: "/images/greetings/mothersday.png",
      serverUrl:`https://firebasestorage.googleapis.com/v0/b/skarvo-sudham-business.firebasestorage.app/o/channel_content_media%2Fgreetings%2F${GreetingsType.mothersday.toLowerCase()}.png?alt=media&token=a618c6ad-f88a-47f9-a3f5-31f8d0b1cfb7`,
      greetingType: GreetingsType.mothersday,
      greetingName: GreetingsType.mothersday,
      greetingPosition: { x: 25, y: 65 },
      greetingTextColor: "#000000",
      IsHaveImage: false,
      greetingImage: "",
    },
    {
      greetingImgSrc: "/images/greetings/veterans.png",
      serverUrl:`https://firebasestorage.googleapis.com/v0/b/skarvo-sudham-business.firebasestorage.app/o/channel_content_media%2Fgreetings%2F${GreetingsType.veterans.toLowerCase()}.png?alt=media&token=a618c6ad-f88a-47f9-a3f5-31f8d0b1cfb7`,
      greetingType: GreetingsType.veterans,
      greetingName: GreetingsType.veterans,
      greetingPosition: { x: 25, y: 35 },
      greetingTextColor: "#000000",
      IsHaveImage: false,
      greetingImage: "",
    },
    {
      greetingImgSrc: "/images/greetings/christmas.png",
      serverUrl:`https://firebasestorage.googleapis.com/v0/b/skarvo-sudham-business.firebasestorage.app/o/channel_content_media%2Fgreetings%2F${GreetingsType.christmas.toLowerCase()}.png?alt=media&token=a618c6ad-f88a-47f9-a3f5-31f8d0b1cfb7`,
      greetingType: GreetingsType.christmas,
      greetingName: GreetingsType.christmas,
      greetingPosition: { x: 25, y: 65 },
      greetingTextColor: "#FFFFFF",
      IsHaveImage: false,
      greetingImage: "",
    },
    {
      greetingImgSrc: "/images/greetings/festivals.png",
      serverUrl:`https://firebasestorage.googleapis.com/v0/b/skarvo-sudham-business.firebasestorage.app/o/channel_content_media%2Fgreetings%2F${"festivals"}.png?alt=media&token=a618c6ad-f88a-47f9-a3f5-31f8d0b1cfb7`,
      greetingType: GreetingsType.festival,
      greetingName: GreetingsType.festival,
      greetingPosition: { x: 25, y: 130 },
      greetingTextColor: "#000000",
      IsHaveImage: false,
      greetingImage: "",
    },
    {
      greetingImgSrc: "/images/greetings/memorable.png",
      serverUrl:`https://firebasestorage.googleapis.com/v0/b/skarvo-sudham-business.firebasestorage.app/o/channel_content_media%2Fgreetings%2F${GreetingsType.memorable.toLowerCase()}.png?alt=media&token=a618c6ad-f88a-47f9-a3f5-31f8d0b1cfb7`,
      greetingType: GreetingsType.memorable,
      greetingName: GreetingsType.memorable,
      greetingPosition: { x: 25, y: 135 },
      imagePosition: { x: 45, y: 25 },
      greetingTextColor: "#000000",
      IsHaveImage: true,
      greetingImage: "",
    },
  ];

  export enum LayoutType {
    table = "horizontalMediaCardList",
    coulmn = "oneColumnMediaCardList",
    grid = "twoColumnMediaCardList",
    text = "oneColumnTextList",
  }

  export enum LayoutJournalType {
    stickNotes = "stickyNote",
    dateTime = "memopad",
    voiceAudio = "voiceMemo",
  }


  export interface CoverMedia {
    coverImageURL: string;
    coverVideoURL?: string;
    coverAudioURL?: string;
  }

  export interface SKArtifactPayload {
    type: ArtifactType | null;
    title: string;
    subtitle:string;
    text?: string;
    topic?: TopicType;
    tier: Tier;
    age?: ContentAgeRestriction;
    status: ContentState;
    subStatus: ContentSubstate;
    coverMedia?:CoverMedia;
    certifyFirst?: boolean;
    certifySecond?: boolean;
    autoPublish?: boolean;
    createdDate?: Timestamp;
    channelId?:string;
    channelStatus?: ChannelState;
    channelName?:string;
    channelImage?:string;
    channelType?: ChannelType;
    language?: string;
    // all filed above are created by creator and below two fields are modified by action of moderators or creators
    lastActivityDate?: Timestamp;
    approvedDate?: Timestamp;
    // all filed below are created/updated by user
    flagged?:boolean;
    loveCount?: number;
    likeCount?: number;
    shareCount?: number;
    views?: number;
    bookmarkCount?: number;
    viewCount?: number;
    reportCount?: number;
    lastReportedDate?: Timestamp;
  }
  export interface SKArtifact extends SKArtifactPayload {
    id: string;
    hasHistory: boolean;
  }

  export interface SKContentStatusHistory{
    createdDate: Timestamp;
    status: ContentState;
    subStatus: ContentSubstate;
    reason?: string;
    note?: string;
  }

  export interface SKPhotoArtifact extends SKArtifact{
    photoURLs: [string];
  }

  export interface SKLinkArtifact extends SKArtifact{
    webURL: string;
    linkName: string;
    linkImagePath: string;
  }

  export interface SKVideoArtifact extends SKArtifact{
    videoURL: string;
  }

  export interface SKAudioArtifact extends SKArtifact{
    audioURL: string;
  }


  export interface SKGreetingArtifact extends SKArtifact{
    greetingType: GreetingsType;
    greetingTitle: string;
    greetingMessage: string;
    greetingImage?: string;
  }

  export interface SKPollArtifact extends SKArtifact{
    question: string;
    options: [string];
    multipleSelection: boolean;
    pollDuration: 3 | 24 | 168
  }
  export interface SKLetterArtifact extends SKArtifact{
    letterTitle: string;
    letterMessage: string;
  }

  export interface SKPlaceArtifact extends SKArtifact{
    location: SKLocation;
    placeDescription: string;
  }

  export interface SKLocation {
    latitude: number;
    longitude: number;
    title: string;
    address: string
    url?: string
  }

  export interface SKDocumentArtifact extends SKArtifact{
    documentPath: string;
    documentName: string;
  }

  export enum EventLocationType{
    online = "online",
    inPerson = "inPerson",
    announcement = "announcement",
    unknown = "unknown"
  }
  
  
  export interface SKEventArtifact extends SKArtifact{
    eventName: string;
    startDate: Timestamp;
    endDate: Timestamp;
    eventLocationType: EventLocationType;
    location: SKLocation;
    eventDescription: string;
  }

  export interface SKListArtifact extends SKArtifact{
    layout: LayoutType;
    listItems : ListArtifactItems[];
  }

  export enum StoryType{
    hybridLayout= "hybridLayout",
  }

  export interface SKStoryArtifact extends SKArtifact{
    storyItems : StoryArtifactItems[];
    storyType: StoryType;
  }

  export interface StoryArtifactItems {
    caption?: string;
    storyMediaType: SKMediaType;
    storyItemURL?: string;
  }

  export interface ListArtifactItems {
    id: string;
    listTitle: string;
    listDescription: string;
    listImage: string;
    listURL: string;
  }

  export enum GuideType {
    locationGuide = "locationGuide"
  }
  export interface SKGuideArtifact extends SKArtifact{
    guideItems : GuideArtifactItems[];
    guideType: GuideType
  }

  
  export interface GuideArtifactItems {
    id: string;
    location: SKLocation;
  }

  export enum PollType{
    freeTextPoll = "freeTextPoll",
    datetimePoll = "dateTimePoll",
    placesPoll = "placesPoll"
  }

  interface PollOption {
    text: string;
    count: number;
  }
  
  interface PollOPtions {
    [key: string]: PollOption ;
  }
  export interface SKPollsArtifact extends SKArtifact{
    pollDuration : string;
    pollQuestion : string;
    pollAnswerType : PollsAnswerType;
    pollsOptionsItems : PollOPtions;
    pollType: PollType;
  }

  export enum PollsAnswerType {
    single = "single",
    multi = "multi"
  }

/*   export interface PollsOptionsItems {
    pollOptionlValue?: string;
  } */

  export interface SKJournalArtifact extends SKArtifact{
    layoutJournal: LayoutJournalType;
    journalItems : JournalArtifactItems[];
  }

  export interface JournalArtifactItems {
    id: string;
    journalTitle?: string;
    journalNote?: string;
    journalVoiceURL?: string;
  }

  export interface SKContentReport {
    reportID: string;
    reportedDate?: Timestamp;
    type?: string;
    message?: string;
    contentID: string,
    userID?: string
    phone?: string;
    osType: string;
    osVersion?: string;
    appVersion?: string;
  }

  // export class SKChannelArtifact implements SKArtifact {
  //   id: string;
  //   type: ArtifactType | null;
  //   title: string;
  //   subtitle: string;
  //   text?: string;
  //   topic?: TopicType;
  //   age?: number;
  //   status: ContentState;
  //   subStatus: ContentSubstate;
  //   coverMedia?: CoverMedia;
  //   certifyFirst?: boolean;
  //   certifySecond?: boolean;
  //   tier: Tier;
  //   autoPublish?: boolean;
  //   createdDate?: Timestamp;
  //   channelId?: string;
  //   channelName?: string;
  //   channelImage?: string;
  //   channelType?: ChannelType;
  //   hasHistory: boolean;
  
  //   constructor({
  //     id,
  //     type,
  //     title,
  //     subtitle,
  //     text,
  //     topic,
  //     age,
  //     status,
  //     subStatus,
  //     coverMedia,
  //     certifyFirst,
  //     certifySecond,
  //     tier,
  //     autoPublish,
  //     createdDate,
  //     channelId,
  //     channelName,
  //     channelImage,
  //     channelType,

  //     hasHistory
  //   }: SKArtifact) {
  //     this.id = id;
  //     this.type = type;
  //     this.title = title;
  //     this.subtitle = subtitle;
  //     this.text = text;
  //     this.topic = topic;
  //     this.age = age;
  //     this.status = status;
  //     this.subStatus = subStatus;
  //     this.coverMedia = coverMedia;
  //     this.certifyFirst = certifyFirst;
  //     this.certifySecond = certifySecond;
  //     this.tier = tier;
  //     this.autoPublish = autoPublish;
  //     this.createdDate = createdDate;
  //     this.channelId = channelId;
  //     this.channelName = channelName;
  //     this.channelImage = channelImage;
  //     this.channelType = channelType;
  //     this.hasHistory = hasHistory;
  //   }
  
  //   // Define the validation schema
  //   // private static validationSchema: ObjectSchema<Omit<SKArtifact, 'validate'>> = Yup.object().shape({
  //   //   id: Yup.string().ensure(),
  //   //   type: Yup.mixed<ArtifactType>().oneOf(Object.values(ArtifactType)).nullable().required('Type is required'),
  //   //   title: Yup.string().required('Title is required').min(3, 'Title is too short'),
  //   //   text: Yup.string().required('Text is required').min(10, 'Text is too short'),
  //   //   topic: Yup.mixed<TopicType>().oneOf(Object.values(TopicType)).optional(),
  //   //   tier: Yup.mixed<Tier>().oneOf(Object.values(Tier)).required('Tier is required'),
  //   //   age: Yup.number().optional().min(0, 'Age must be a positive number'),
  //   //   status: Yup.mixed<State>().oneOf(Object.values(State)).required('Status is required'),
  //   //   coverImage: Yup.string().optional(),
  //   //   coverAudio: Yup.string().optional(),
  //   //   coverVideo: Yup.string().optional(),
  //   //   certifyFirst: Yup.boolean().optional(),
  //   //   certifySecond: Yup.boolean().optional(),
  //   //   autoPublish: Yup.boolean().optional(),
  //   //   createdDate: Yup.mixed<Timestamp>().optional()
  //   // });
  
  //   // Method to validate the current instance of SKChannelArtifact
  // //   async validate(): Promise<SKArtifact> {
  // //     try {
  // //       const validatedInstance = await SKChannelArtifact.validationSchema.validate(this, { abortEarly: false });
  // //       return validatedInstance;
  // //     } catch (error) {
  // //       if (error instanceof Yup.ValidationError) {
  // //         const validationErrors: Record<string, string> = {};
  // //         error.inner.forEach((err) => {
  // //           if (err.path) {
  // //             validationErrors[err.path] = err.message;
  // //           }
  // //         });
  // //         throw validationErrors;
  // //       }
  // //       throw error;
  // //     }
  // //   }
  //  }